<template>
<div class="modal" @click="$emit('close')">
  <div class="modal-content" @click.stop="">

    <div class="modal-header">
      <button class="close-button" @click="$emit('close')"><i class="fa fa-times-circle close-button-icon"></i></button>
    </div>

    <div class="modal-content-left">
      <slot name="modal-content-left">
        default header
      </slot>
    </div>
                
    <div class="modal-content-right">
      <slot name="modal-content-right">
        default body
      </slot>
    </div>

  </div>

</div>
</template>

<script>
export default {
}
</script>

<style scoped>
.modal{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 20;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}
.modal-content {
  /* align-items: stretch; */
  background-color: var(--global-background-color);
  /* margin: auto; */
  padding: 20px;
  /* width: 60%; */
  display: flex;
  flex-wrap: wrap;

}
.modal-header{
  /* padding: 2px 16px; */
  /* display: flex; */
  /* flex-direction: column; */
  /* display: grid; */
  /* flex-wrap: 3; */
  flex-basis: 100%;
  /* padding-top: 10px; */
}

/* .modal-columns{
  display: grid;
  grid-template-columns: auto auto;
} */
.modal-content-left {
  /* margin: 20px 0;
  margin-right: 10px; */
  flex: 1;
  padding: 10px;
}
.modal-content-right{
  /* margin: 20px 0; */
  flex: 1;
  padding: 10px;
}
.close-button{
  background: none;
  border: none;
  /* position: fixed; */
  float: right;
  cursor: pointer;
}

 @media (max-width: 760px){
  .modal{
    top: 0;
    left: 0;
    transform: none;
    display: block;
    overflow-y: scroll;
    height: 100%;
  }
  .modal-content{
    padding: 10px;
  }
  .modal-content-left{
    padding: 0px;
  }
  .modal-content-right{
    padding: 0;
    width: 100%;
  }
  .modal-header{
    margin-bottom: 5px;
  }
}



/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>